__turbopack_context__.v({
  "pbs_app_search_row": "zT6YsG_pbs_app_search_row",
  "pbs_app_search_row__content": "zT6YsG_pbs_app_search_row__content",
  "pbs_app_search_row__description": "zT6YsG_pbs_app_search_row__description",
  "pbs_app_search_row__devices_image": "zT6YsG_pbs_app_search_row__devices_image",
  "pbs_app_search_row__devices_image_link": "zT6YsG_pbs_app_search_row__devices_image_link",
  "pbs_app_search_row__title": "zT6YsG_pbs_app_search_row__title",
});
